import api from '@/api/API';

// eslint-disable-next-line import/prefer-default-export
export function setup(companyId: string, apiKey: string): Promise<void> {
  return api
    .put(`companies/${companyId}/setup`, { apiKey })
    .then(() => undefined);
}
